export const COMMON_TOGGLE_LEFT_DRAWER = 'COMMON_TOGGLE_LEFT_DRAWER';
